module.exports = __webpack_public_path__ + "img/突破科技，启迪未来.ee15ffcd.png";